import { useEffect } from 'react';
import { hasConsentFor } from '@/utils/cookieConsent';

interface MicrosoftClarityProps {
  projectId?: string;
}

declare global {
  interface Window {
    clarity: any;
  }
}

export const MicrosoftClarity = ({ projectId = 'tavqs0sk00' }: MicrosoftClarityProps) => {
  useEffect(() => {
    if (!projectId) {
      return;
    }

    const handleConsentUpdate = () => {
      if (hasConsentFor('analytics')) {
        // Initialize Microsoft Clarity
        if (!window.clarity) {
          const c: any = window;
          const l: any = document;
          const a = "clarity";
          const r = "script";
          const i = projectId;
          
          c[a] = c[a] || function(){(c[a].q = c[a].q || []).push(arguments)};
          const t = l.createElement(r);
          t.async = 1;
          t.src = "https://www.clarity.ms/tag/" + i;
          const y = l.getElementsByTagName(r)[0];
          y.parentNode.insertBefore(t, y);
        }
      } else {
        // Remove Clarity if consent is revoked
        const clarityScript = document.querySelector('script[src*="clarity.ms"]');
        if (clarityScript) {
          clarityScript.remove();
        }
        if (window.clarity) {
          delete window.clarity;
        }
      }
    };

    // Listen for cookie consent updates
    window.addEventListener('cookieConsentUpdated', handleConsentUpdate);

    // Initialize on mount if consent already given
    handleConsentUpdate();

    return () => {
      window.removeEventListener('cookieConsentUpdated', handleConsentUpdate);
    };
  }, [projectId]);

  return null;
};